import React from 'react';

interface ButtonProps {
  onClick: () => void;
  size?: number;
  color?: string;
}

export const CloseButton: React.FC<ButtonProps> = ({ onClick, size = 44, color = '#c39d63' }) => {
  return (
    <button onClick={onClick} className="group relative p-2" style={{ background: "transparent", border: "none" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group-hover:scale-110 transition-transform duration-300"
      >
        <path d="M6 6L18 18" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M6 18L18 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
      </svg>
    </button>
  );
};

export const HamburgerButton: React.FC<ButtonProps> = ({ onClick, size = 44, color = '#c39d63' }) => {
  return (
    <button onClick={onClick} className="group relative p-2" style={{ background: "transparent", border: "none" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group-hover:scale-110 transition-transform duration-300"
      >
        <path d="M4 6H20" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M4 12H20" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M4 18H20" stroke={color} strokeWidth="2" strokeLinecap="round" />
      </svg>
    </button>
  );
};
